import { captureError } from '@/shared/lib/errors/capture';

const NEW_USER_FLAG_KEY = 'tabootv_is_new_user';

export function setNewUserFlag(): void {
  try {
    sessionStorage.setItem(NEW_USER_FLAG_KEY, '1');
  } catch (error) {
    captureError(error, {
      component: 'NewUserFlag',
      action: 'set',
      severity: 'info',
      skipPostHog: true,
    });
  }
}

export function isNewUserSession(): boolean {
  try {
    return sessionStorage.getItem(NEW_USER_FLAG_KEY) === '1';
  } catch (error) {
    captureError(error, {
      component: 'NewUserFlag',
      action: 'get',
      severity: 'info',
      skipPostHog: true,
    });
    return false;
  }
}

export function clearNewUserFlag(): void {
  try {
    sessionStorage.removeItem(NEW_USER_FLAG_KEY);
  } catch (error) {
    captureError(error, {
      component: 'NewUserFlag',
      action: 'clear',
      severity: 'info',
      skipPostHog: true,
    });
  }
}
